/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.ui.color
 * @memberof vef.ui
 */

import * as colorScales from './colorScales.js';
export { colorScales };

export * from './Utils.js';
export * from './ColorSlider.js';
export * from './ColorScalePicker.js';
export * from './ColorScaleDropdown.js';
export * from './ColorizedImage.js';